import { ShieldAlert } from "lucide-react";

export default function ProtectionOverlay({ visible }) {
  if (!visible) return null;
  return (
    <div
      data-testid="protection-overlay"
      className="fixed inset-0 z-[100] bg-marino/95 backdrop-blur-sm flex items-center justify-center p-6"
    >
      <div className="bg-white border border-naranja rounded-2xl p-8 max-w-md text-center shadow-2xl">
        <div className="w-14 h-14 rounded-full bg-naranja/10 text-naranja flex items-center justify-center mx-auto mb-4">
          <ShieldAlert className="w-8 h-8" strokeWidth={1.75} />
        </div>
        <h2 className="font-heading font-black text-2xl text-marino">Contenido protegido</h2>
        <p className="mt-3 text-marino/80">
          Hemos detectado herramientas de desarrollo abiertas. Por favor ciérralas para continuar con tu curso.
        </p>
        <p className="mt-3 text-xs text-marino/60">
          Cualquier intento de copiar, descargar o inspeccionar el contenido queda registrado.
        </p>
      </div>
    </div>
  );
}
